var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20711 10.7929C5.81658 10.4024 5.18342 10.4024 4.79289 10.7929C4.40237 11.1834 4.40237 11.8166 4.79289 12.2071L9.29289 16.7071C9.68342 17.0976 10.3166 17.0976 10.7071 16.7071L19.2071 8.20711C19.5976 7.81658 19.5976 7.18342 19.2071 6.79289C18.8166 6.40237 18.1834 6.40237 17.7929 6.79289L10 14.5858L6.20711 10.7929Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWide);
export default __webpack_public_path__ + "static/media/check-wide.f64ee2ea469d505e4d98dfbb4a198f1b.svg";
export { ForwardRef as ReactComponent };